export default function chargebeeBookmarklet() {
  return `javascript:void(
    function() {
      const els = {
        chargebee: "#customer-acc-details-info dd"
      };

      let foundEl = null;

      Object.entries(els).forEach(([name, selector]) => {
          const div = document.querySelector(selector);
          if (div) {
          foundEl = div;
          }
      });

      if (foundEl) {
        window.open(
          "https://frontapp-plugin.netlify.com/?info=" + encodeURIComponent(foundEl.innerText)
        )
      } else {
        alert("Non ho trovato niente!");
      }
    }()
  )`
    .split(/\n/)
    .map((l) => l.replace(/^ */, ''))
    .join('');
}
